module.exports = __webpack_public_path__ + "img/chat_five.e2797cec.png";